module.exports = __webpack_public_path__ + "img/SAP_introduce_txt.d8689bc0.png";